import { render, staticRenderFns } from "./step.vue?vue&type=template&id=581bfbf7&scoped=true&"
import script from "./step.vue?vue&type=script&lang=js&"
export * from "./step.vue?vue&type=script&lang=js&"
import style0 from "./step.vue?vue&type=style&index=0&id=581bfbf7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581bfbf7",
  null
  
)

export default component.exports